import thunk from "redux-thunk";
import promise from "redux-promise";
import logger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import { createStore, applyMiddleware, combineReducers } from "redux";
import game from "./reducers/GameReducer";
const store = createStore(
  combineReducers({
    game
  }),
  composeWithDevTools(
    applyMiddleware(...composeWithDevTools, thunk, promise, logger)
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js